import CompetenceLimits from './CompetenceLimits';
import MinimumConfiguration from './MinimumConfiguration';

export function getCpcRecommendation(trovitData) {
  const competenceLimits = new CompetenceLimits(trovitData.competenceLimits);
  const minimumConfiguration = new MinimumConfiguration(trovitData.minimum);
  return competenceLimits.getNewCampaignRecommendedCpc(minimumConfiguration);
}
